import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function replaceAt(
  str: string,
  position: number,
  replaceTo: string | number
) {
  if (position < 0 || position >= str.length) {
    throw new Error('Position n is out of bounds')
  }
  return str.slice(0, position) + replaceTo + str.slice(position + 1)
}

export function keyBy(array: any) {
  const byKey: Record<string, string> = {}

  if (!array) {
    return byKey
  }

  array.forEach((item: string) => (byKey[item] = item))

  return byKey
}
